import { AxiosResponse } from 'axios';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import * as Sentry from '@sentry/react';
import api from '../../../services/api';
import { ActionTypes, ILayersState } from './types';
import { IGetLayers } from '../../../types/layers';
import {
  getLayersRequest,
  getLayersSuccess,
  getLayersFailure,
} from './actions';

type GetLayersRequest = ReturnType<typeof getLayersRequest>;

export function* getLayer({ payload }: GetLayersRequest): any {
  const { jwt, user } = payload.input;

  const unitsNames: string[] = [];
  user.units.map(unit => unitsNames.push(unit.name));

  const data: ILayersState = {
    regions: [],
    roads: [],
  };

  try {
    const regionsResponse: AxiosResponse<IGetLayers> = yield call(
      api.get,
      `region/layer/${unitsNames}`,
      {
        headers: {
          'x-access-token': jwt,
        },
      },
    );

    if (regionsResponse.data.status === 'success') {
      data.regions = regionsResponse.data.data;
    }

    const roadsResponse: AxiosResponse<IGetLayers> = yield call(
      api.get,
      `road/layer/${unitsNames}`,
      {
        headers: {
          'x-access-token': jwt,
        },
      },
    );

    if (roadsResponse.data.status === 'success') {
      data.roads = roadsResponse.data.data;
    }

    yield put(getLayersSuccess(data));
  } catch (err) {
    Sentry.captureException(err);
    yield put(getLayersFailure(data));
  }
}

export default all([takeLatest(ActionTypes.getLayersRequest, getLayer)]);
